module.exports = __webpack_public_path__ + "img/single.749773c4.svg";